import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'overview-item-four',
  templateUrl: './item-one.component.html',
  styles: []
})
export class ItemFourComponent implements OnInit {
	@Input() job: any;
	constructor() {
		
	}
	ngOnInit() {
	}
}